// Repair the known localized policy URL only inside Shopify's privacy UI.
// Shopify continues to own consent, controls, storage and privacy events.
(() => {
  const marker = 'gvPolicyLinkReady';
  if (document.documentElement.dataset[marker]) return;
  document.documentElement.dataset[marker] = 'true';
  const roots = '#shopify-pc__banner, #shopify-pc__prefs';
  const repairLink = (link) => {
    if (!link.matches('a[href]') || !link.closest(roots)) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || url.pathname !== '/lt/policies/privacy-policy') return;
    url.pathname = '/policies/privacy-policy';
    link.href = url.href;
  };
  const repairTree = (node) => {
    if (!(node instanceof Element)) return;
    repairLink(node);
    for (const link of node.querySelectorAll('a[href]')) repairLink(link);
  };
  // One observer; examine only added subtrees or a changed href, without polling
  // or rescanning the whole document during gallery, cart and finder updates.
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') repairLink(record.target);
      else for (const node of record.addedNodes) repairTree(node);
    }
  });
  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    for (const root of document.querySelectorAll(roots)) repairTree(root);
  };
  start();
  addEventListener('pagehide', () => observer.disconnect());
  // A restored bfcache page keeps its script instance; resume that same observer.
  addEventListener('pageshow', start);
})();
